module.exports = __webpack_public_path__ + "img/m3.85adfd52.jpeg";